// extracted by mini-css-extract-plugin
var _1 = "StatisticTabs-moduletab__GCUzs Tab-moduleTab__yRe6s";
export { _1 as "tab" }
